import { Navigate, Route, Routes } from 'react-router-dom';
import { LayoutCard } from '@features/workspace/components/layouts/v2/layout';
import BankingAccountRouter from '@features/workspace/views/banking/account';
import BankingAccountEmpty from '@features/workspace/views/banking/empty';
import { useAppSelector } from '@store/hooks';
import {
  selectBankAccounts,
  selectIsBankAccountsLoading,
} from '@features/workspace/store/selectors';
import { Loading } from '@features/workspace/components/layouts/v2/loading';
import * as React from 'react';
import BankingLayout from '@components/layout/BankingLayout';
import { IBankAccount } from '../../types';

const BankingRouter = () => {
  const bankAccounts: IBankAccount[] = useAppSelector(selectBankAccounts);

  const isBankAccountsLoading = useAppSelector(selectIsBankAccountsLoading);

  if (isBankAccountsLoading) {
    return (
      <BankingLayout>
        <LayoutCard>
          <Loading />
        </LayoutCard>
      </BankingLayout>
    );
  }

  return (
    <Routes>
      <Route element={<BankingAccountRouter />} path="/:account_id/*" />
      <Route
        element={
          bankAccounts.length ? (
            <Navigate
              replace
              to={`/customer/banking/${bankAccounts[0].accountNumber}/transactions`}
            />
          ) : (
            <BankingAccountEmpty />
          )
        }
        path="/"
      />
    </Routes>
  );
};

export default BankingRouter;
